import { ScheduleContribution } from "@assets";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { Flow } from "@ctypes";
import { useGoalFlow } from "@hooks";
import { i18n, Translations } from "@i18n";
import { convertCentsToDollar, formatCurrency } from "@utils";
import { useStyles } from "./styles";
import { SharedContributionCardProps } from "./types";

export const SharedContributionCard = ({
  name,
  contributionLabel,
  recurringDepositInCents,
}: SharedContributionCardProps) => {
  const styles = useStyles();

  const {
    goalProps: { flow, pendingInvite },
  } = useGoalFlow();

  if (
    flow !== Flow.AcceptSharedGoal ||
    !pendingInvite?.inviterFirstName ||
    !pendingInvite.recurringDepositInCents
  ) {
    return null;
  }

  const contributionAmount = formatCurrency(convertCentsToDollar(recurringDepositInCents));

  return (
    <>
      <div style={styles.container}>
        <ScheduleContribution />
        <div style={styles.content}>
          <Body style={styles.title}>
            {i18n.t(Translations.SharedContributionCardTitle, { name })}
          </Body>
          <Spacing size={SpacingSizes.XXXS} />

          <Body style={styles.subtitle}>
            {contributionAmount} | {contributionLabel}
          </Body>
        </div>
      </div>
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
